import type { AppJob } from "@/lib/api";
import { i18n } from "@/lib/i18n";

import { jobErrorText } from "../bezetting/job-errors";

/**
 * What a failed Maandrapport recompute says: Bezettingsgraad's words, except where the check differs (Odoo gave far
 * fewer invoices or orders than usual, not cranes).
 */
export function maandrapportJobErrorText(
  job: Pick<AppJob, "error">,
  previousKept: boolean,
): string {
  if (job.error !== "odoo_data_missing") {
    return jobErrorText(job, previousKept);
  }
  const text = i18n.t("apps.maandrapport.jobErrors.odoo_data_missing");
  return previousKept ? `${text} ${i18n.t("apps.previousKept")}` : text;
}
